export const PROSECUTION = 1;
export const PUBLIC_DEFENSE = 2;
export const PARTICULAR_DEFENSE = 3;
export const JUDGE = 4;
export const OPERATOR = 5;
export const ACCUSED = 6;
export const VICTIM = 7;
export const INTERVEENING = 8;
export const NEW_DESTINATION = 9;

export default [
    {
        id: PROSECUTION,
        descripcion: 'FISCALÍA'
    },
    {
        id: PUBLIC_DEFENSE,
        descripcion: 'DEFENSA PÚBLICA'
    },
    {
        id: PARTICULAR_DEFENSE,
        descripcion: 'DEFENSA PARTICULAR'
    },
    {
        id: JUDGE,
        descripcion: 'JUEZ'
    },
    {
        id: OPERATOR,
        descripcion: 'OPERADOR'
    },
    {
        id: ACCUSED,
        descripcion: 'IMPUTADOS'
    },
    {
        id: VICTIM,
        descripcion: 'VICTIMA'
    },
    {
        id: INTERVEENING,
        descripcion: 'INTERVINIENTE'
    },
    {
        id: NEW_DESTINATION,
        descripcion: 'NUEVO'
    }
]